module.exports = __webpack_public_path__ + "img/logo-email-reset.2d3110f1.png";